import React, { memo } from 'react';
import cn from 'classnames';
import { Svg } from '@/shared/ui/Svg';
import LogoIcon from '@/shared/assets/icons/complex/logo/logo-black.complex.svg';
import { NotificationLink } from './components/NotificationLink';
import { UserProfile } from './components/UserProfile';
import styles from './Header.module.scss';

interface HeaderProps {
  className?: string;
  onUserActions?: () => void;
  onSettings?: () => void;
  onLogout?: () => void;
}

export const Header = memo(({ className }: HeaderProps) => (
  <>
    <header className={cn(styles.root, className)}>
      <div className={styles.content}>
        <div className="flex items-center justify-between gap-2 w-full">
          <div className="flex gap-6 items-center ">
            <Svg Icon={LogoIcon} width={246} height={38} role="img" aria-label="International Humanitarian College London" />
          </div>
          <div className="flex items-center gap-3">
            <NotificationLink />
            <UserProfile />
          </div>
        </div>
      </div>
    </header>
  </>
));
